import { Injectable } from '@angular/core';

import {EncryptiondecryptionService} from "./encryptiondecryption.service";
import {environment} from '../../environments/environment';

import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private apiKey: string;

  constructor(private router: Router) {
    environment.razorPayKey
    .then(res => {
      this.apiKey =  res;
    })
    .catch(err => {
      console.log('message',err);
    })
  }



  options(price,name,email,contact,notes,type){
    let self = this;
    return {
       "key": EncryptiondecryptionService.getDecry('123456$#@$^@1ERF',this.apiKey), // Enter the Live Key ID generated from the Dashboard
      "amount": price, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise or INR 500.
      "currency": "INR",
      "name": "MindPeers",
      "description": "India’s first self-care platform Measure your mental health, get affordable qualitative therapists and vent out your feelings!",
      "image": "https://mindpeers.co/assets/images/1.png",
      "handler": function (response) {

         let redirect_url;
        if (typeof response.razorpay_payment_id == 'undefined' || response.razorpay_payment_id < 1) {
          redirect_url = '/failure-page';
          // alert('Error');
        } else {
          alert('Appointment booked successfully');
          // redirect_url = `/success-page/${type}/` + btoa(EncryptiondecryptionService.setEncry('123456$#@$^@1ERF',response.razorpay_payment_id));
          if(type == 'appointment'){
            redirect_url = '/appointments-list/active';
          }else{
            redirect_url = '/appointments-list/active';
            // redirect_url = `/success-page/${type}/` + btoa(EncryptiondecryptionService.setEncry('123456$#@$^@1ERF',response.razorpay_payment_id));
          }

        }
        location.href = redirect_url;

      },
      "prefill": {
        "name": name,
        "email": email,
        "contact": contact
      },
      "notes": notes,
      "theme": {
        "color": "#16a9b1"
      }
      // ,
      // external: {
      //   wallets: ['paytm'],
      //   handler: function (data) {
      //     console.log(data)
      //   }
      // }
    };
  }




}
